import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { accountService, alertService } from '../_services';

function VerifyEmail({ history }) {
    const EmailStatus = {
        Verifying: 'Verifying',
        Failed: 'Failed'
    }
    
    const {t} = useTranslation();

    const [emailStatus, setEmailStatus] = useState(EmailStatus.Verifying);

    useEffect(() => {
        //const { token } = queryString.parse(location.search);

        // remove token from url to prevent http referer leakage
        //history.replace(location.pathname);

        accountService.verifyEmail()
            .then(() => {
                setEmailStatus(EmailStatus.Verifying);
            })
            .catch(() => {
                setEmailStatus(EmailStatus.Failed);
            });
    }, []);

    function getBody() {
        switch (emailStatus) {
            case EmailStatus.Verifying:
                return <div>
                    <p>{t("paragraphVerifyEmail1")} </p>
                    <p>{t("paragraphVerifyEmail2")} </p>
                    <Link to="/" className="btn btn-link">{t('Home')}</Link>
                </div>;
            case EmailStatus.Failed:
                return <div> {t("msgEmailVeriFailed1")}  <Link to="forgot-password">{t("ForgotPassword")} </Link> {t("msgEmailVeriFailed2")} </div>;
        }
    }

    return (
        <div>
            <h3 className="card-header">{t("VerifyEmail")} </h3>
            <div className="card-body">{getBody()}</div>
        </div>
    )
}

export { VerifyEmail }; 